export const EDITOR_MODES = {
  ELEMENTS: "elements",
  STORY: "story",
};
